<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">

        <mat-icon class="logo-icon mr-16" *fuseIfOnDom >account_balance</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom >{{'main.organization' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center"
        [style.display]="isOrganizer ? 'none' : 'flex'">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>
        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" style="display: none">
          <input id="search1" autocomplete="off" matInput #filter2 placeholder="{{'main.search' | translate}}">
        </mat-form-field>
        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="page-search">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search" matInput #filter>
        </mat-form-field>
      </div>
      <!-- / SEARCH -->

      @if (!isOrganizer) {
        <button mat-raised-button
          [routerLink]="'/pages/organization/new'"
          class="add-product-button mat-white-bg my-12 mt-sm-0">
          <span>{{'organization.add_new_organization' | translate}}</span>
        </button>
      }
      @if (!isOrganizer) {
        <button mat-button class="mat-icon-button sidenav-toggle ml-12"
          fuseMatSidenavToggler="organization-main-sidenav"
          fxHide.gt-lg>
          <mat-icon>filter_list</mat-icon>
        </button>
      }
    </div>
    <!-- / HEADER -->

    <mat-sidenav-container class="my-sidenav" style="  position: absolute;
    width: 210px;
    height: calc(100vh - 210px);
    right: 0;
    z-index: 999;
    top: 136px;
    background: transparent;">
      <mat-sidenav #sidenav class="sidenav mat-sidenav-opened" position="end" opened="true" mode="side"
                   fuseMatSidenavHelper="organization-main-sidenav" mat-is-locked-open="gt-sm" [ngClass]="{'hide-menu': !sidenav.opened}" style="    position: absolute;
    width: 100%;
    margin: 0px;
    display: flex;
    flex: 1 1 0%;
    flex-direction: column;
    overflow: hidden;
    transform: none;
    visibility: visible;">
        <filter-menu [filters]="filterData" [page]="'organization'" [filterFromDB]="userFilters"
        (chooseFilter)="chooseFilters($event)"></filter-menu>
      </mat-sidenav>
    </mat-sidenav-container>

    <div class="content-card mat-white-bg margin-big-screen"
          [ngClass]="{'margin-big-screen': !isOrganizer && sidenav?.opened}">

  <mat-table class="products-table"
    #table [dataSource]="organizations"
    matSort
    [@animateStagger]="{value:'50'}"
    fusePerfectScrollbar>


    <!-- Name Column -->
    <ng-container cdkColumnDef="name">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'canton.name' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let organization">
        <p class="text-truncate">{{organization?.name}}</p>
      </mat-cell>
    </ng-container>
    <!-- Image Column -->
    <ng-container cdkColumnDef="logo">
      <mat-header-cell *cdkHeaderCellDef></mat-header-cell>
      <mat-cell *cdkCellDef="let organization">
        @if (organization.logo) {
          <img class="product-image"
            [alt]="organization.name"
            [src]="getImage(organization.logo)"/>
        }
        @if (!organization.logo) {
          <img class="product-image" [src]="'assets/images/organization_black.svg'">
        }
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="organizationType">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'organization.organizationType' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let organization">
        <p class="text-truncate">{{organization?.organizationType?.name}}</p>
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="country">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'organization.country' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let organization">
        <img style="height: 40px" [src]="'assets/images/' + organization.country.flag + '.svg'"/>
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="canton">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'organization.canton' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let organization">
        @if (organization.city.name) {
          <p class="text-truncate">{{organization?.city?.name}}</p>
        }
        @if (organization.city[0] && organization.city[0].name) {
          <p class="text-truncate"
          matTooltip="{{organization.cities}}"  [matTooltipPosition]="'above'">{{organization?.city[0]?.name}}...</p>
        }
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="city">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'organization.city' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let organization">
        <p class="text-truncate">{{organization?.cityLocation}}</p>
      </mat-cell>
    </ng-container>

    <!-- Code Column -->
    <ng-container cdkColumnDef="postcode">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'organization.postcode' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let organization">
        <p class="text-truncate">{{organization?.postcode}}</p>
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="address">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'organization.address' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let organization">
        <p class="text-truncate">{{organization?.address}}</p>
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="website">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'organization.website' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let organization">
        <p class="text-truncate">{{organization?.website}}</p>
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="test">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header style="flex: 0 0 80px;"></mat-header-cell>
      <mat-cell *cdkCellDef="let organization" style="flex: 0 0 80px;">
        @if (organization?.isTest) {
          <p class="text-truncate test-org">TEST</p>
        }
      </mat-cell>
    </ng-container>

    <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

    <mat-row *cdkRowDef="let organization; columns: displayedColumns;"
      class="product"
      matRipple
      [routerLink]="'/pages/organization/detail'" [queryParams]="{id: organization.id}">
    </mat-row>

  </mat-table>
  @if (organizations.filteredData.length === 0) {
    <div class="no-data-msg">
      <span class="mat-headline-6">{{'main.noData' | translate}}</span>
    </div>
  }
  <mat-paginator #paginator
    [length]="organizations.filteredData.length"
    [pageIndex]="0"
    [pageSize]="50"
    [pageSizeOptions]="[25, 50, 100]">
  </mat-paginator>
</div>
<!-- / CONTENT CARD -->
</div>
<!-- / CENTER -->
</div>



